import React, { useState } from "react";
import {
  CancelButton,
  DetailsContainer,
  EditButtons,
  InfoHeader,
  RowContent,
  RowItem,
  SaveButton,
} from "../styles";
import { TbPencil, TbPhoneCall } from "react-icons/tb";
import { Client } from "@domain/models/Client";
import TextInput from "@components/Form/TextInput/TextInput";
import { reportResultOptions } from "@domain/models/Report";

type Props = {
  client: Client;
  inEdit: boolean;
  isAdmin: boolean;
  isManager: boolean;
  handleActiveEdit?: (section: string) => void;
  handleSaveClient?: (newClient: Partial<Client>) => void;
  onClose?: () => void;
};

type SubSection = {
  name: string;
  field: keyof Pick<Client, "rejection">;
  subField: keyof Client["rejection"];
  disabled: boolean;
};

const subSections: SubSection[] = [
  {
    name: "NB",
    field: "rejection",
    subField: "nb",
    disabled: false,
  },
  {
    name: "Resultado",
    field: "rejection",
    subField: "reason",
    disabled: false,
  },
  {
    name: "Data do indeferimento",
    field: "rejection",
    subField: "date",
    disabled: false,
  },
  {
    name: "Data da Der",
    field: "rejection",
    subField: "derDate",
    disabled: false,
  },
];

const RejectionSection = ({
  client,
  inEdit,
  isAdmin,
  isManager,
  handleActiveEdit,
  handleSaveClient,
  onClose,
}: Props) => {
  const defaultState: Partial<Client> = { rejection: client.rejection };
  const [newObj, setNewObj] = useState<Partial<Client>>(defaultState);

  const handleEdit = (field: string, subField: string, value: string) => {
    setNewObj({
      ...newObj,
      [field]: {
        ...newObj[field],
        [subField]: value,
      },
    });
  };

  const handleCancel = () => {
    setNewObj(defaultState);
    onClose();
  };

  return (
    <DetailsContainer>
      <InfoHeader>
        <div>
          <TbPhoneCall size={22} color="var(--red)" />
          <p>Indeferimento</p>
          {!inEdit &&
            (isAdmin ||
              (isManager &&
                client.lastReportResult === reportResultOptions.RECOMMENDATION_SIGNED)) && (
              <TbPencil
                onClick={() => handleActiveEdit("rejection")}
                size={22}
                style={{ strokeWidth: 1.5, cursor: "pointer" }}
              />
            )}
        </div>
        {inEdit && (
          <EditButtons>
            <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
            <SaveButton onClick={() => handleSaveClient(newObj)}>Salvar edição</SaveButton>
          </EditButtons>
        )}
      </InfoHeader>
      <RowContent>
        {subSections.map((item, index) => (
          <RowItem key={index}>
            <h3>{item.name}</h3>
            {inEdit ? (
              <TextInput
                name={item.subField}
                defaultValue={client[item.field][item.subField]}
                onChange={(value) => handleEdit(item.field, item.subField, value)}
              />
            ) : (
              <p>{client[item.field][item.subField]}</p>
            )}
          </RowItem>
        ))}
      </RowContent>
    </DetailsContainer>
  );
};

export default RejectionSection;
